export const SCHEMA_SUMMARY = [
  {
    table_id: 'plug_output_summary',
    col_id: 'plug_id',
    col_name: 'Plug ID #',
    col_desc: 'Plug ID #',
    col_unit: '-',
    ui_editable: false,
    ui_show: false,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'plug_name',
    col_name: 'Plug Name',
    col_desc: 'Plug Name',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'plugging_method',
    col_name: 'Plugging Method',
    col_desc: 'Balanced Plug or Squeeze (Bridge Plug and Dump Bailer rows are not calculated)',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'design_type',
    col_name: 'Design Type',
    col_desc: 'How the plug was produced: Manual, Regulation or Recommendation',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_cement',
    col_name: 'Volume of Cement',
    col_desc: 'Fluid Volume',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 't_total',
    col_name: 'Total Time',
    col_desc: 'Required Total Time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'plug_top_depth_ann',
    col_name: 'Top of Plug',
    col_desc:
      'Top Depth of Cement Plug (Squeeze: top of the cement behind the casing assuming all squeezed cement fills the annulus; the NM #13 excess is counted as lost; closed annulus: the perforation depth, nothing rises)',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'plug_bot_depth',
    col_name: 'Design Depth',
    col_desc: 'Bottom Depth of Designed Plug',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },

  {
    table_id: 'plug_output_summary',
    col_id: 'm_cement_slurry',
    col_name: 'Fluid Weight',
    col_desc: 'Fluid Weight',
    col_unit: 'lb',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'm_cement',
    col_name: 'Dry Cement Weight',
    col_desc: 'Dry Cement Weight',
    col_unit: 'lb',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'sk_cement',
    col_name: 'Dry Cement Volume',
    col_desc: 'Dry Cement Volume',
    col_unit: 'sk',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'percent_water',
    col_name: 'Water Percentage',
    col_desc: 'Water Percentage in Cement',
    col_unit: '%',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 't_mixing',
    col_name: 'Mixing Time',
    col_desc: 'Cement Mixing Time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'int',
    decimal: 0
  },
  {
    table_id: 'plug_output_summary',
    col_id: 't_pump',
    col_name: 'Pumping Time',
    col_desc: 'Lead Cement Pumping Time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'int',
    decimal: 0
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'den_cement',
    col_name: 'Cement Density',
    col_desc: 'Cement Slurry Density',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'p_bottom',
    col_name: 'Pressure at Bottom',
    col_desc: 'Maximum annulus pressure at the plug bottom during the job',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'ECD_bottom',
    col_name: 'ECD at Bottom',
    col_desc: 'Equivalent Circulating Density at Bottom',
    col_unit: 'ppg',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },

  {
    table_id: 'plug_output_summary',
    col_id: 'vol_spacer_lead',
    col_name: 'Volume of Spacer',
    col_desc: 'Lead Spacer Volume',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_spacer_tail',
    col_name: 'Volume of Tail Spacer',
    col_desc: 'Tail Spacer Volume',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_water',
    col_name: 'Volume of Water',
    col_desc: 'Mixing Water Volume',
    col_unit: 'bbl',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_cement_tub',
    col_name: 'Cement in Tubing',
    col_desc: 'Cement volume left in the work string / casing bore',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_cement_ann',
    col_name: 'Cement in Annulus',
    col_desc: 'Cement volume placed in the annulus',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_displacement',
    col_name: 'Displacement Volume',
    col_desc: 'Displacement fluid pumped behind the cement',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_mud',
    col_name: 'Mud Volume',
    col_desc: 'Mud ahead of the spacer in the annulus',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },

  {
    table_id: 'plug_output_summary',
    col_id: 't_spacer_lead',
    col_name: 'Spacer Pumping Time',
    col_desc: 'Time to Pump Lead Spacer',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 't_cement',
    col_name: 'Cement Pumping Time',
    col_desc: 'Time to Pump Cement',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 't_spacer_tail',
    col_name: 'Tail Spacer Pumping Time',
    col_desc: 'Time to Pump Tail Spacer',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 't_displacement',
    col_name: 'Displacement Pumping Time',
    col_desc: 'Time to Pump Displacement',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },

  {
    table_id: 'plug_output_summary',
    col_id: 'm_water',
    col_name: 'Mass of Water',
    col_desc: 'Mixing Water Mass',
    col_unit: 'lb',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'm_spacer_lead',
    col_name: 'Mass of Spacer',
    col_desc: 'Lead Spacer Mass',
    col_unit: 'lb',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'm_spacer_tail',
    col_name: 'Mass of Tail Spacer',
    col_desc: 'Tail Spacer Mass',
    col_unit: 'lb',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },

  {
    table_id: 'plug_output_summary',
    col_id: 'gal_water_per_sk',
    col_name: 'Water per Sack',
    col_desc: 'Gallons of Water per Sack of Cement',
    col_unit: 'gal/sk',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'top_cement_bf_pooh',
    col_name: 'Top of Cement (before POOH)',
    col_desc: 'Top of Cement before Pulling Out Of Hole',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'top_cement_af_pooh',
    col_name: 'Top of Cement (after POOH)',
    col_desc: 'Top of Cement after Pulling Out Of Hole',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'top_spacer_bf_pooh',
    col_name: 'Top of Spacer (before POOH)',
    col_desc: 'Top of Spacer before Pulling Out Of Hole',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'top_spacer_af_pooh',
    col_name: 'Top of Spacer (after POOH)',
    col_desc: 'Top of Spacer after Pulling Out Of Hole',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_cement_casing',
    col_name: 'Cement below Retainer',
    col_desc: 'Squeeze: cement left in the casing between the cement retainer and the perforation',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'vol_cement_squeeze',
    col_name: 'Cement Squeezed',
    col_desc: 'Squeeze: cement pushed through the perforations; ',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'packer_depth',
    col_name: 'Retainer Depth',
    col_desc: 'Squeeze: depth of the cement retainer the cement is pumped through',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'perf_depth',
    col_name: 'Perforation Depth',
    col_desc: 'Squeeze: depth of the perforations the cement is squeezed through',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'p_perf_max',
    col_name: 'Max Perforation Pressure',
    col_desc: 'Squeeze: highest pressure at the perforations during the job',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'dp_perf_max',
    col_name: 'Max Perforation Pressure Drop',
    col_desc: 'Squeeze: highest orifice pressure drop through the perforations during the job',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'net_pressure',
    col_name: 'Net Pressure',
    col_desc: 'Squeeze with a closed annulus: net pressure used (pressure at the perforation = fracture pressure + net pressure)',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_summary',
    col_id: 'warning',
    col_name: 'Warning',
    col_desc: 'Squeeze: warning raised by the calculation (e.g. fracture pressure exceeded at the perforations)',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  }
];

export default SCHEMA_SUMMARY;
